<div class="lmo-well-status-warning" *ngIf="report">
  <div class="lmo-well-status-warning-content">
    <div class="alert-icon">
      <mat-icon>notifications_none</mat-icon>
    </div>
    <div class="message">
      <div class="header">Well Reported Down at {{ report.createdTimestamp | date: 'medium' }}</div>
      <div class="sub-header" *ngIf="report.description && report.description.length > 0">
        {{ report.reportedUser }} reported {{ report.site?.name }} down for {{ report.eta | minutesToHuman }}: "{{
          report.description
        }}".
      </div>

      <div class="sub-header" *ngIf="!report.description || report.description.length === 0">
        {{ report.reportedUser }} reported {{ report.site?.name }} down for {{ report.eta | minutesToHuman }}
      </div>
    </div>
    <a
      class="actions"
      *saAllowedAccountRoles="['admin', 'dispatcher']"
      [routerLink]="['./', 'lmo_frac_home_modal', 'create_frac_report']"
      >Update Well Status</a
    >
  </div>
</div>
